exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new-data-inputs > .col-1[data-v-ec403dec],\n.new-data-inputs .col-2[data-v-ec403dec],\n.new-data-inputs .col-[data-v-ec403dec],\n.new-data-inputs .col-4[data-v-ec403dec] {\n  display: flex;\n  align-items: center;\n}", ""]);

// exports
